import NavLink from '@/features/blog/detail/NavLink';
import { ArticleDetail } from '@/lib/contentful/api/getArticle';
import { BlogI18n } from '@/lib/i18n/blogI18n';

const ArticleNavigation = ({
  prev,
  next,
  locale,
  t,
}: ArticleNavigationProps) => {
  if (!prev && !next) return null;

  return (
    <nav className="mt-16 pt-8 border-t border-primary/20 flex justify-between gap-8">
      {prev ? (
        <NavLink
          article={prev}
          locale={locale}
          label={t.previous}
          direction="prev"
        />
      ) : (
        <div />
      )}
      {next ? (
        <NavLink
          article={next}
          locale={locale}
          label={t.next}
          direction="next"
        />
      ) : (
        <div />
      )}
    </nav>
  );
};

export default ArticleNavigation;

type ArticleNavigationProps = {
  prev: ArticleDetail['prev'];
  next: ArticleDetail['next'];
  locale: string;
  t: BlogI18n;
};
